import { EventBadge } from "../lib/eventStyle";

/**
 * The left half of the sign-in screens, built like the app's home screen: the
 * same photograph, the same mark in an orange circle, the same bold title.
 *
 * Colours here are fixed rather than themed. It sits on a photograph, which is
 * dark whatever the viewer's setting, so light-mode tokens would put black
 * text on a burning hillside.
 *
 * The sample strip shows what the product actually produces, so someone
 * landing here can tell what it is.
 */
const STRIP = [
  { t: "06:12", event: "engineStarted", label: "Engine start", detail: "VH-SRN · 412 L" },
  { t: "06:24", event: "takeoff", label: "Takeoff", detail: "Kilmore Gap" },
  { t: "06:41", event: "drop", label: "Drop", detail: "Mt Disappointment" },
  { t: "06:58", event: "drop", label: "Drop", detail: "Mt Disappointment" },
  { t: "07:20", event: "landed", label: "Landed", detail: "Leg 1 · 0.9 h" },
];

export function Brand() {
  return (
    <div className="theme-dark relative h-full overflow-hidden bg-black text-white">
      <img
        src="/brand/drop.jpg"
        alt=""
        className="absolute inset-0 w-full h-full object-cover"
        aria-hidden
      />
      {/* Keeps white text legible over the bright smoke without hiding the photo. */}
      <div
        className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/25 to-black/80"
        aria-hidden
      />

      <div className="relative h-full flex flex-col justify-between p-10 lg:p-14">
        <div className="flex items-center gap-4">
          <span className="grid place-items-center w-16 h-16 rounded-full bg-accent shrink-0">
            <img src="/brand/firefly-mark.png" alt="" className="w-[88%] h-[88%] object-contain" />
          </span>
          <div>
            <p className="text-[2rem] leading-none font-bold tracking-tight">FireFly</p>
            <p className="mt-1 text-[1rem] font-semibold text-white/80">Fleet</p>
          </div>
        </div>

        <div className="max-w-md">
          <p className="text-[1.35rem] leading-snug font-semibold">
            Mission logs from every aircraft in your fleet, in one place.
          </p>

          {/* Mirrors the translucent header card the app shows over its map. */}
          <div className="hidden sm:block mt-6 rounded-xl bg-black/60 backdrop-blur-md border border-white/10 p-4">
            <p className="text-[0.85rem] font-semibold text-white/70 mb-2">Today · VH-SRN</p>
            <ul className="flex flex-col gap-2">
              {STRIP.map((row, i) => (
                <li key={i} className="flex items-center gap-3">
                  <span className="font-mono text-[0.9rem] text-white/75 tabular-nums w-12">{row.t}</span>
                  <EventBadge event={row.event} />
                  <span className="text-[0.95rem] font-semibold w-28">{row.label}</span>
                  <span className="text-[0.9rem] text-white/70 truncate">{row.detail}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}
